import { keepPreviousData, useQuery, type UseQueryResult } from '@tanstack/react-query';

import type { ApiError } from '../api/client';
import { adminApi, type ActivityParams } from '../api/endpoints';
import type { ActivityFilterOptions, ActivityItem, Page } from '../types/api';
import { queryKeys } from './keys';

export function useActivity(
  params: ActivityParams,
  enabled = true,
): UseQueryResult<Page<ActivityItem>, ApiError> {
  return useQuery<Page<ActivityItem>, ApiError>({
    queryKey: queryKeys.adminActivity(params),
    queryFn: () => adminApi.activity(params),
    enabled,
    placeholderData: keepPreviousData,
    retry: (failureCount, error) => !error.isNotFound && !error.isUnauthorized && failureCount < 2,
  });
}

export function useActivityFilters(enabled = true): UseQueryResult<ActivityFilterOptions, ApiError> {
  return useQuery<ActivityFilterOptions, ApiError>({
    queryKey: queryKeys.adminActivityFilters,
    queryFn: () => adminApi.activityFilters(),
    enabled,
    staleTime: 30_000,
  });
}
